import { faBuildings } from '@fortawesome/pro-light-svg-icons'
import {
  ResidentialApartmentPropertyDetails,
  ResidentialHousePropertyDetails,
  ResidentialType,
} from '@unreserved-frontend-v2/api/generated/graphql/types'
import {
  DetailsTableBooleanFieldConfig,
  DetailsTableRow,
  DETAILS_TABLE_BOOLEAN_FIELDS,
} from '@unreserved-frontend-v2/ui/details-table/models'
import { emptyDefault } from '@unreserved-frontend-v2/utils/empty-default'
import useTranslation from 'next-translate/useTranslation'
import { useMemo } from 'react'
import { EXPOSURE_LABELS } from '../../../../types/exposure'

export const useCondoRow = (
  details?: ResidentialApartmentPropertyDetails | ResidentialHousePropertyDetails | null
): DetailsTableRow | undefined => {
  const { t } = useTranslation()
  return useMemo(() => {
    if (details?.residentialType !== ResidentialType.Apartment) {
      return
    }
    const condo = details as ResidentialApartmentPropertyDetails

    let hasInSuiteLaundry: DetailsTableBooleanFieldConfig | null = null

    if (condo.hasInSuiteLaundry != null) {
      hasInSuiteLaundry = DETAILS_TABLE_BOOLEAN_FIELDS[condo.hasInSuiteLaundry ? 'yes' : 'no']
    }

    const exposureValue = emptyDefault(condo.exposure != null ? t(EXPOSURE_LABELS[condo.exposure]) : null)

    let locker: DetailsTableBooleanFieldConfig | null = null

    if (condo.lockerOwned != null) {
      locker = DETAILS_TABLE_BOOLEAN_FIELDS[condo.lockerOwned ? 'yes' : 'no']
    }

    if (!condo.balconyRaw && condo.hasInSuiteLaundry == null && condo.exposure == null && condo.lockerOwned == null) {
      return
    }

    return {
      icon: faBuildings,
      title: t('listings:details-pages.condo'),
      cells: [
        {
          id: 'condo',
          data: [
            {
              id: 'data-lot-balcony-type',
              label: t('listings:details-pages.balcony-type'),
              value: emptyDefault(condo?.balconyRaw),
            },
            {
              id: 'data-in-suite-laundry',
              label: t('listings:details-pages.in-suite-laundry'),
              value: emptyDefault(t(hasInSuiteLaundry?.key || '')),
              icon: hasInSuiteLaundry?.icon,
            },
          ],
        },
        {
          id: 'condo-2',
          data: [
            {
              id: 'data-exposure',
              label: t('listings:details-pages.exposure'),
              value: exposureValue,
            },
            {
              id: 'data-locker',
              label: t('listings:details-pages.locker'),
              value: emptyDefault(t(locker?.key || '')),
              icon: locker?.icon,
            },
          ],
        },
      ],
    }
  }, [details, t])
}
